<template>
    <div class="large">
        <template v-if="aspectRatioWidth && aspectRatioHeight">
            <aspect-ratio :ratio-width="aspectRatioWidth" :ratio-height="aspectRatioHeight">
                <v-lazy-image :src="src" :placeholder="placeholder" :srcset="srcset" class="masterImg" :alt="alt" />
            </aspect-ratio>
        </template>
        <template v-if="aspectRatioWidth == null || aspectRatioHeight == null">
            <v-lazy-image :src="src" :placeholder="placeholder" :srcset="srcset" class="masterImg" :alt="alt" />
        </template>
        
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";
    import AspectRatio from "./atoms/AspectRatio.vue";
    export default {
        name: "CarouselImageLarge",
        components: {
            VLazyImage,
            AspectRatio
        },
        props: ["src", "srcset", "placeholder", "alt", "aspectRatioWidth", "aspectRatioHeight"]
    };
</script>
<style scoped lang="scss">

</style>